var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _polygon, _path11, _path12, _path13, _polygon2, _path14, _path15, _circle, _path16, _path17, _path18, _path19, _path20, _line;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCenter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a0f752ea-7802-4b2f-97ae-90aebf84c2db",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 878.5,
    height: 701.25952,
    viewBox: "0 0 878.5 701.25952",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "content creator") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 97.5,
    width: 186,
    height: 151,
    fill: "#11cdef"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 294.5,
    width: 515,
    height: 16,
    fill: "#f2f2f2"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 88.5,
    width: 186,
    height: 151,
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 303,
    y: 139,
    width: 180,
    height: 16,
    fill: "#f2f2f2"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 303,
    y: 182,
    width: 255,
    height: 16,
    fill: "#f2f2f2"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 130,
    width: 180,
    height: 16,
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 173,
    width: 255,
    height: 16,
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 285.5,
    width: 515,
    height: 16,
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 344.5,
    width: 515,
    height: 16,
    fill: "#f2f2f2"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 335.5,
    width: 515,
    height: 16,
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 394.5,
    width: 515,
    height: 16,
    fill: "#f2f2f2"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 385.5,
    width: 515,
    height: 16,
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 444.5,
    width: 515,
    height: 16,
    fill: "#f2f2f2"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 435.5,
    width: 515,
    height: 16,
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 494.5,
    width: 515,
    height: 16,
    fill: "#f2f2f2"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 485.5,
    width: 515,
    height: 16,
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 544.5,
    width: 515,
    height: 16,
    fill: "#f2f2f2"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 535.5,
    width: 515,
    height: 16,
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 587,
    height: 648,
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M972.35751,677.86917a20.38226,20.38226,0,1,0,2.7143-39.09006l.51016,10.49075-4.96337-8.99067a20.3054,20.3054,0,0,0-10.4628,11.48027,19.9866,19.9866,0,0,0-1.17238,5.51347A20.37836,20.37836,0,0,0,972.35751,677.86917Z",
    transform: "translate(-160.5 -99.12024)",
    fill: "#57b894"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M996.91642,799.54407c-1.75207-8.92193,5.84-16.83149,13.33928-21.97268s16.2617-10.19262,18.82045-18.91749c3.67739-12.53917-7.27642-24.0227-15.80206-33.9256a122.7093,122.7093,0,0,1-16.182-24.0497,33.10537,33.10537,0,0,1-3.87051-10.93542c-.67222-5.55813,1.11343-11.089,2.91242-16.39072q8.98948-26.49244,19.22264-52.54093",
    transform: "translate(-160.5 -99.12024)",
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M973.1969,675.16825a20.38226,20.38226,0,1,0,2.7143-39.09006l.51017,10.49074-4.96337-8.99066a20.30536,20.30536,0,0,0-10.46281,11.48026,19.98709,19.98709,0,0,0-1.17237,5.51348A20.37836,20.37836,0,0,0,973.1969,675.16825Z",
    transform: "translate(-160.5 -99.12024)",
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M994.42521,617.18864a20.35845,20.35845,0,0,1,14.67024-12.9248l1.67819,9.97325,3.11135-10.47455a20.37974,20.37974,0,1,1-19.45978,13.4261Z",
    transform: "translate(-160.5 -99.12024)",
    fill: "#57b894"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M995.5444,613.5874a20.35847,20.35847,0,0,1,14.67025-12.92479l1.67819,9.97325,3.11134-10.47455A20.37974,20.37974,0,1,1,995.5444,613.5874Z",
    transform: "translate(-160.5 -99.12024)",
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1009.69623,724.93043a20.3798,20.3798,0,0,0,18.03825-36.25729l-2.39074,8.04934-1.69527-10.0908a.35339.35339,0,0,0-.05188-.01968,20.38089,20.38089,0,1,0-13.90036,38.31843Z",
    transform: "translate(-160.5 -99.12024)",
    fill: "#57b894"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1010.666,721.28275a20.3798,20.3798,0,0,0,18.03825-36.25729l-2.39074,8.04934-1.69526-10.0908a.35542.35542,0,0,0-.05188-.01968,20.38089,20.38089,0,1,0-13.90037,38.31843Z",
    transform: "translate(-160.5 -99.12024)",
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M988.47723,758.77854a20.37128,20.37128,0,1,0,3.92767-15.96045l9.081,13.668-12.408-7.25455A20.19026,20.19026,0,0,0,988.47723,758.77854Z",
    transform: "translate(-160.5 -99.12024)",
    fill: "#57b894"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M989.31663,756.07761a20.37128,20.37128,0,1,0,3.92767-15.96044l9.081,13.668-12.408-7.25454A20.1901,20.1901,0,0,0,989.31663,756.07761Z",
    transform: "translate(-160.5 -99.12024)",
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M748.5,334.12024s12.5,26.5,10.5,34.5a21.89979,21.89979,0,0,0,1.5,14.5l23-1,21.5-20.5s-32.5-22.5-30.5-33.5S748.5,334.12024,748.5,334.12024Z",
    transform: "translate(-160.5 -99.12024)",
    fill: "#a0616a"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M806.5,376.12024l10,62s0,56-3,57-16,0-16,0v-63l4-55Z",
    transform: "translate(-160.5 -99.12024)",
    fill: "#11cdef"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M806.5,376.12024l10,62s0,56-3,57-16,0-16,0v-63l4-55Z",
    transform: "translate(-160.5 -99.12024)",
    opacity: 0.1
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "706 641 714 672 726 663 737 638 723 621 706 641",
    fill: "#a0616a"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M897.5,733.12024s-13,10-13,20c0,0-7,11-15,10v21s-25,13-6,16,33-21,33-21,18-29,15-33S897.5,733.12024,897.5,733.12024Z",
    transform: "translate(-160.5 -99.12024)",
    fill: "#3f3d56"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M806.42577,490.39366S825.5,511.12024,816.5,543.12024c0,0-10,72,22,99s53,86,53,86l-24,22s-26-59-53-82-30-49-30-49v-91l-5-38Z",
    transform: "translate(-160.5 -99.12024)",
    fill: "#3f3d56"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M806.42577,490.39366S825.5,511.12024,816.5,543.12024c0,0-10,72,22,99s53,86,53,86l-24,22s-26-59-53-82-30-49-30-49v-91l-5-38Z",
    transform: "translate(-160.5 -99.12024)",
    opacity: 0.1
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "621 664 611 675 615 684 627 688 648 680 645 668 621 664",
    fill: "#a0616a"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M811.5,774.12024s-24,12-30,7a16.0338,16.0338,0,0,1-5.983-11.41874s-12.017,1.41874-20.017,6.41874-14,11-24,11-6,12,13,13,67-1,67-6Z",
    transform: "translate(-160.5 -99.12024)",
    fill: "#3f3d56"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M743.5,503.12024s-13,58,10,124c0,0,11,37,16,48s10,89,8,92c0,0,16,13,30,4,0,0-1-46,1-50s4-39-8-68-2-99-2-99,24-36,6-57Z",
    transform: "translate(-160.5 -99.12024)",
    fill: "#3f3d56"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 598,
    cy: 214,
    r: 28,
    fill: "#a0616a"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M810.5,496.12s-8,12-14,6c-4.23-4.23-31.31006,4.96-46.92993,10.75-6.54,2.42-11.07007,4.25-11.07007,4.25s-.42993-13.86-1.69995-31.41c-1.46-20.13995-4.02-45.16-8.30005-59.59-8-27,12-38,12-38s17-20,16-23,45-18,45-18c5,1,9,46,9,46s-9,36-14,58S810.5,496.12,810.5,496.12Z",
    transform: "translate(-160.5 -99.12024)",
    fill: "#11cdef"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M724.5,497.12024s-22,22-33,28-17,26-8,30,29-22,29-22l29-24Z",
    transform: "translate(-160.5 -99.12024)",
    fill: "#a0616a"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M728.65727,296.39793c-2.558.22812-4.0199,3.44912-3.19434,5.88094s3.19824,4.0225,5.6216,4.87255,5.01415,1.14106,7.44021,1.98338a21.89655,21.89655,0,0,1,6.614,3.84072c6.91192,5.66067,11.00515,14.286,12.3077,23.12462s.00445,17.89637-2.45248,26.486c-1.30158,4.55042-3.42684,9.53735-7.875,11.15419a88.476,88.476,0,0,0,14.20225-4.81627c3.36342-1.58427,6.51968-3.5893,9.91937-5.09416a62.19177,62.19177,0,0,1,15.70463-4.11793c3.78551-.58939,7.78734-1.03922,11.34232.38892a22.7998,22.7998,0,0,1,5.94475,4.00868l11.435,9.608q.29856-6.26589.39447-12.53927c.05556-3.63508.04145-7.37482-1.29807-10.75455-1.32249-3.33677-3.83372-6.05676-5.51423-9.22833-4.1579-7.847-2.80322-17.3-2.72578-26.18016.08018-9.19459-1.39971-18.56518-5.65724-26.71505s-11.525-14.97485-20.39019-17.415c-11.94885-3.289-24.54545,1.60633-35.52877,7.3473a32.22406,32.22406,0,0,0-7.164,4.6635,34.81924,34.81924,0,0,0-5.82437,7.94138l-5.43775,9.1122",
    transform: "translate(-160.5 -99.12024)",
    fill: "#3f3d56"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M799.5,403.12s-19,72-21,77c-1.43994,3.59-18.38,22.69-28.92993,32.75-6.54,2.42-11.07007,4.25-11.07007,4.25s-.42993-13.86-1.69995-31.41C744.93994,476.68,753.5,468.12,753.5,468.12s9-55,8-76,20-26,20-26C805.5,369.12,799.5,403.12,799.5,403.12Z",
    transform: "translate(-160.5 -99.12024)",
    opacity: 0.1
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M778.5,362.12024s-21,5-20,26-8,76-8,76-34,34-31,38,15.85321,11.86376,18.92661,12.93188S773.5,481.12024,775.5,476.12024s21-77,21-77S802.5,365.12024,778.5,362.12024Z",
    transform: "translate(-160.5 -99.12024)",
    fill: "#11cdef"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 509.5,
    y1: 700.5,
    x2: 878.5,
    y2: 700.5,
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCenter);
export default __webpack_public_path__ + "static/media/center.adcc2e6f6621df900c9d3d1bdc69ae45.svg";
export { ForwardRef as ReactComponent };